export enum FuncTypes {
  Check = 1,
  Appraisal = 2,
  Approve = 3,
  Evaluate = 4,
}

// Function to convert the enum to a display string
export const funcTypeToString = (funcType: FuncTypes): string => {
  switch (funcType) {
    case FuncTypes.Check:
      return 'kiểm tra';
    case FuncTypes.Appraisal:
      return 'thẩm định';
    case FuncTypes.Approve:
      return 'phê duyệt';
    case FuncTypes.Evaluate:
      return 'đánh giá';
    default:
      return undefined;
  }
};
